export function inIframe() {
  return window.self !== window.top
}

export function notInIframe() {
  return !inIframe();
}
